export const OtpRegex = /^\d{6}$/;
export const drugCodeRegExp = /^\d{1,6}$/;
export const phoneRegExp = /^([0|\+[0-9]{1,5})?([6-9][0-9]{9})$/
export const EmergencyphoneRegExp = /^[0-9]*$/;
export const LinkValidationRegex =
    /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
export const phoneRegSpace = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/;
export const alphaletter = /^(?!\s)[a-zA-Z ]*$|^(?!\s)[\u0900-\u097F ]*$/;
export const userNameAlphaLetter = /^[A-Za-z\s]+$/ ;
export const alphaletterwithApostrophe = /^(?!\s)[a-zA-Z ]+('[a-zA-Z ])?[a-zA-Z ]*$|^(?!\s)[\u0900-\u097F ]*$/;
export const noWhiteSpace = /^(?!\s)/;
export const alphaLetterWithHypen =
    /^[ A-Za-z\-_']*$|^(?!\s)[ \u0900-\u097F\-_']*$/;
export const alphaWoutSpeChar =
    /^([ A-Za-z\-_']+\s?)*$|^((?!\s)[\u0900-\u097F\-_']+\s?)*$/;
export const alphaWoutSpeCharCommaWithAndHypen = /^([A-Za-z\,-_']+\s?)*$/;
export const alphaWithAndOperator =
    /^[ .&a-zA-Z\,-]+$|^(?!\s)[ .&\u0900-\u097F\,-]+$/;
export const alphaNumericletter = /^(?!\s)[0-9\-_'][a-zA-Z ]*$/;
export const alphaNewmericLetterforUserId = /^[a-z0-9]{5,20}$/;
export const NumWoutSpeChar = /^([0-9\-_']+\s?)*$/;
export const alphaWithCompulsaryNumberRexExp =
    /[^\w\d]*(([A-Za-z]+.*[A-Za-z0-9\,_']+.*)|[A-Za-z0-9\,_']+.*([A-Za-z]+.*))|^(?!\s)[\u0900-\u097F ]*$/;
export const alphaNumericWithNumberRexExp = /^[A-Za-z0-9]+([.][0-9]+)?$/;
export const pinCodeRegExp = /^.{6,}$/;
export const MultiSixDigitRegex = /^(\s*\d{6}\s*)(,\s*\d{6}\s*)*,?\s*$/;
export const stdCodeRegExp = /^.{3,}$/;
export const aadhaarRegExp = /^\d{12}$/;
export const emailRegex = /^[a-z][a-z0-9._%+-]*@[a-z0-9.-]+\.[a-z]{2,}$/;
export const telephoneRegex = /^(\d{4}([-]*)\d{7})$/;
export const NotSpecailCharacterregex = /^[a-zA-Z0-9_]*$/;
export const panRegExp = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
export const passwordRegex =
    /^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[!@#$%^&*()\-__+.]){1,}).{8,}$/;
export const NumberWithDecimalRegex = /^[0-9]+([.][0-9]+)?$/;
export const NumberRegex = /^[0-9]*$/;
export const DecimalNumberRegex = /^[1-9]\d*(\.\d+)?$/;
export const alphanumericHypenRegex =
    /^[a-z0-9]+([-\s]{1}[a-z0-9]+)*$|^(?!\s)([ \u0900-\u097F\,-]+)*$/i;
export const alphaWoutSpeCharComma =
    /^([ A-Za-z\,_']+\s?)*$|^(?!\s)([ \u0900-\u097F\,_']+\s?)*$/;
export const latValidation =
    /^(\+|-)?((\d((\.)|\.\d{1,6})?)|(0*?[0-8]\d((\.)|\.\d{1,6})?)|(0*?90((\.)|\.0{1,6})?))$/;
export const longValidation =
    /^(\+|-)?((\d((\.)|\.\d{1,6})?)|(0*?\d\d((\.)|\.\d{1,6})?)|(0*?1[0-7]\d((\.)|\.\d{1,6})?)|(0*?180((\.)|\.0{1,6})?))$/;
export const RatingRegex = /^([1-4]|5)$/;
export const NumericRange1to100Regex = /^[0-9][0-9]?$|^100$/;
export const NumericTempRangeRegex = /^(-10|-[1-9]|[0-5]?[0-9]|60)([ ])?-([ ])?(([(])?-10([)])?|-([(])?[1-9]([)])?|[[0-5]?[0-9]|60)$/;
export const HexRegex = /^#[a-fA-F0-9]{6}$/;
export const alphanewmericwithoutspace = /^[a-z0-9!@#$%^&*()_+={}\[\]:;"'<>,.?/|~-]+$/;
export const addressRegex = /^[0-9a-zA-Z\s,-]+$/;
export const addressWithEnglishOnly = /^[\x00-\x7F]*$/;
export const alphabetwithcomma = /^[a-zA-Z\s,-]+$/
export const panNumber = /[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}/
export const GSTNumberRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const emailRegexWithOutCapitalChar = /^[a-z][a-z0-9._%+-]*@[a-z0-9.-]+\.[a-z]{2,}$/;
export const faxIdRegex = /^(\(\d{3}\) \d{3}-\d{4}|\d{3}[-.]\d{3}[-.]\d{4})$/;
export const NameHasOnlySmallAndCapitalStringregex = /^[a-zA-Z]+$/;
export const alphaletterWithDotAndApostropheComa = /^(?!\s)[a-zA-Z\u0900-\u097F.' ,]*$/;
export const mrp = /^\d+(\.\d+)?$/;
export const shouldAplhaNumric = /^[a-zA-Z0-9]{7}$/;
export const AplhaNumric = /^[a-zA-Z0-9]{6}$/;
export const alphanumrice =  /^[a-zA-Z0-9]+$/;
export const spacailEmailDomainRegex = /^[a-zA-Z0-9._%+-]+@(janaushadhi\.gov\.in|nic\.in|gov\.in|gmail\.com|hotmail\.com|yahoo\.com)$/;
;

export const onInputChange = (input) => {
    let { value, maxLength } = input.target;
    if (value.length > maxLength) {
        input.target.value = value.slice(0, maxLength);
    }
};


